import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { SOCIAL } from "@/lib/api";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 sm:py-28 bg-[#FFFBF0] border-y-2 border-[#3F2A56]/10"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-8 text-center">
        <span className="font-script text-2xl text-[#b85b7e]">say hi</span>
        <h2 className="font-display font-bold text-4xl sm:text-5xl text-[#3F2A56] mt-2 leading-tight">
          Contact Happy Tails by Aurora
        </h2>
        <p className="mt-4 text-[#5C4A73] text-lg max-w-2xl mx-auto leading-relaxed">
          Have a question, want to schedule a free meet &amp; greet, or ready
          to book? I&rsquo;d love to hear from you and your furry family.
        </p>

        <div className="mt-12 grid sm:grid-cols-2 gap-5 text-left">
          <ContactCard
            icon={Phone}
            label="Call or text"
            value={SOCIAL.phone}
            href={`tel:${SOCIAL.phoneRaw}`}
            testid="contact-phone"
          />
          <ContactCard
            icon={Mail}
            label="Email"
            value={SOCIAL.email}
            href={`mailto:${SOCIAL.email}`}
            testid="contact-email"
          />
          <ContactCard
            icon={Facebook}
            label="Facebook"
            value="Happy Tails by Aurora"
            href={SOCIAL.facebook}
            external
            testid="contact-facebook"
          />
          <ContactCard
            icon={Instagram}
            label="Instagram"
            value={SOCIAL.instagramHandle}
            href={SOCIAL.instagram}
            external
            testid="contact-instagram"
          />
        </div>

        <div className="mt-10 inline-flex items-center gap-3 px-6 py-3 rounded-full bg-[#3F2A56]/5 border border-[#3F2A56]/15">
          <MapPin className="w-4 h-4 text-[#3F2A56]" />
          <span className="font-semibold text-[#3F2A56]">
            Locally owned and operated in the {SOCIAL.area}
          </span>
        </div>
      </div>
    </section>
  );
}

function ContactCard({ icon: Icon, label, value, href, external, testid }) {
  const Wrap = href ? "a" : "div";
  const props = href
    ? { href, ...(external ? { target: "_blank", rel: "noopener noreferrer" } : {}) }
    : {};
  return (
    <Wrap
      data-testid={testid}
      {...props}
      className="flex items-center gap-4 p-5 rounded-2xl bg-[#F4E8C8]/60 border-2 border-[#3F2A56]/15 hover:-translate-y-0.5 hover:bg-[#F4E8C8] transition-all"
    >
      <div className="w-12 h-12 rounded-full bg-[#3F2A56] text-[#F4E8C8] grid place-items-center shrink-0">
        <Icon className="w-5 h-5" />
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-[#5C4A73]">{label}</div>
        <div className="font-display text-xl font-semibold text-[#3F2A56] break-all">
          {value}
        </div>
      </div>
    </Wrap>
  );
}
